module.exports = __webpack_public_path__ + "static/img/ico_qrcode.5177d67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultural_products/ico_qrcode.png
// module id = Q/E2
// module chunks = 0